<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Cabin:wght@400;700&display=swap');

@font-face {
  font-family: 'Avenir';
  src: url('../public/phil/AvenirMedium.woff');
  font-weight: normal;
}

@font-face {
  font-family: 'Avenir';
  src: url('../public/phil/AvenirBold.woff');
  font-weight: 600;
}

:root {
  --xl-text: 48px;
  --big-text: 36px;
  --med-text: 24px;
  --email-width: 350px;
}

@media (max-width: 600px) {
  :root {
    --xl-text: 36px;
    --big-text: 24px;
    --med-text: 18px;
    --email-width: 250px;
  }
}
</style>

<style lang="scss" scoped>
</style>
